// https://lucide.dev/icons/
import { createElement, icons } from 'lucide';

const toPascalCase = (name) => name.split('-').map((s) => s.charAt(0).toUpperCase() + s.slice(1)).join('');

window.fetchIcon = (name) => {
  const icon = icons[toPascalCase(name)];
  return Promise.resolve(icon ? createElement(icon) : null);
};
